(function () {
  'use strict';

  var API_BASE = 'https://backend-pre-prod.up.railway.app/api/delivery/status';
  var SHOP_DOMAIN = 'shopforw.myshopify.com';
  var PIN_KEY = 'ExistPincode';
  var SESSION_PIN_KEY = 'WfwSessionPincode';
  var SESSION_CACHE_PREFIX = 'WfwDeliveryCache:v4:';
  var NUDGE_DWELL_MS = 2000;
  var CACHE_TTL = 5 * 60 * 1000;
  var cache = new Map();
  var inflight = new Map();
  /** Skip duplicate attribution when setPincode also dispatches wfw:pincode-updated. */
  var skipNextAttributionEvent = false;
  var prefilledAttributionDone = false;
  var lastAttributedPin = null;
  var lastSlaViewKey = null;
  var lastPaintedPin = null;
  var FEATURE_NAME = 'delivery_check';
  var SECTION_ID = 'product_delivery_check';
  var ID_PINCODE_ENTERED = 'pincode_entered';
  var ID_SAVED_PINCODE = 'saved_pincode';
  var ID_WITHIN_2_DAYS = 'within_2_days';
  var ID_WITHIN_3_DAYS = 'within_3_days';

  function config() {
    return window.WFWDeliverySla || {};
  }

  function getProductHandle() {
    var cfg = config();
    if (cfg.productHandle) return String(cfg.productHandle);
    try {
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function featureTags(subFeatureId) {
    return {
      name: FEATURE_NAME,
      id: subFeatureId,
      strategyId: subFeatureId,
      variant: 'variant',
      source: 'custom-liquid',
      sectionId: SECTION_ID,
    };
  }

  function sourceOfExistingPin(pin) {
    var cfg = config();
    if (cfg.isLoggedIn && isValidPin(cfg.customerPincode) && String(cfg.customerPincode).trim() === String(pin || '').trim()) {
      return 'customer';
    }
    try {
      if (isValidPin(localStorage.getItem(PIN_KEY))) return 'localStorage';
    } catch (e) {}
    return 'session';
  }

  function whenHeliumReady(cb) {
    if (
      window.HeliumUtils &&
      window.HeliumUtils.tracking &&
      window.HeliumUtils.tracking.feature
    ) {
      cb();
      return;
    }
    var tries = 0;
    var t = setInterval(function () {
      if (
        (window.HeliumUtils &&
          window.HeliumUtils.tracking &&
          window.HeliumUtils.tracking.feature) ||
        tries++ > 40
      ) {
        clearInterval(t);
        cb();
      }
    }, 250);
  }

  function trackPincodeSubFeature(subFeatureId, extra) {
    var run = function () {
      try {
        var feature =
          window.HeliumUtils &&
          window.HeliumUtils.tracking &&
          window.HeliumUtils.tracking.feature;
        if (!feature || typeof feature.triggered !== 'function') return;
        feature.triggered(
          featureTags(subFeatureId),
          Object.assign({ did_render: true, page_type: 'product' }, extra || {})
        );
      } catch (e) {}
    };

    whenHeliumReady(function () {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout: 800 });
      } else {
        setTimeout(run, 0);
      }
    });
  }

  function appendFeatureParamsFallback(url, tags) {
    try {
      var u = new URL(url, window.location.origin);
      if (tags.name) u.searchParams.set('feature', String(tags.name));
      if (tags.id) u.searchParams.set('feature_id', String(tags.id));
      if (tags.variant) u.searchParams.set('feature_variant', String(tags.variant));
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function stampUrlWithFeature(tags) {
    var tracking = window.HeliumUtils && window.HeliumUtils.tracking;
    var next;
    if (tracking && typeof tracking.appendFeatureParams === 'function') {
      next = tracking.appendFeatureParams(window.location.href, tags);
    } else {
      next = appendFeatureParamsFallback(window.location.href, tags);
    }
    try {
      if (next && next !== window.location.pathname + window.location.search + window.location.hash) {
        window.history.replaceState({}, '', next);
      }
    } catch (e) {}
  }

  function stampHeliumLineProperties(form) {
    if (!form || form.tagName !== 'FORM') return;
    ['_helium_feature', '_helium_feature_id'].forEach(function (key) {
      var name = 'properties[' + key + ']';
      form.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        if (input.parentNode) input.parentNode.removeChild(input);
      });
    });
  }

  function stampPdpDirectAttribution(featureId) {
    var id = featureId || ID_PINCODE_ENTERED;
    var tags = featureTags(id);
    if (id === ID_PINCODE_ENTERED) {
      stampUrlWithFeature(tags);
    }

    var selectors = [
      'form[action*="/cart/add"]',
      'product-form',
      '[data-product-form]',
      '.product-form',
      'button[name="add"]',
      '[data-add-to-cart]',
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('data-feature', FEATURE_NAME);
        el.setAttribute('data-feature-id', id);
        el.setAttribute('data-feature-variant', 'variant');
        el.setAttribute('data-feature-strategy-id', id);
      });
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      stampHeliumLineProperties(form, id);
    });

    var tracking = window.HeliumUtils && window.HeliumUtils.tracking;
    if (tracking && typeof tracking.tagElement === 'function') {
      var productRoot =
        document.querySelector('product-info') ||
        document.querySelector('[data-product-id]') ||
        document.querySelector('.product');
      if (productRoot) tracking.tagElement(productRoot, tags);
    }
  }

  var ATTR_STORAGE_KEY = 'helium_feature_attribution';

  function readAttributionMap() {
    try {
      var raw = sessionStorage.getItem(ATTR_STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  /**
   * Last-click for Command Center: cart notes `_helium_feature` /
   * `_helium_feature_id` / `_helium_attribution`. Pulse on W does not expose
   * window.helium.attribution.persistAttribution, so we write the same shape.
   */
  function writeHeliumCartAttribution(handle, featureId) {
    if (!handle || !featureId) return;

    var map = readAttributionMap();
    map[handle] = {
      feature: FEATURE_NAME,
      feature_id: featureId,
      ts: Date.now(),
    };

    try {
      sessionStorage.setItem(ATTR_STORAGE_KEY, JSON.stringify(map));
    } catch (e) {}

    var ordered = Object.keys(map)
      .filter(function (h) {
        var row = map[h];
        return h && row && row.feature && row.feature_id;
      })
      .sort(function (a, b) {
        return (map[a].ts || 0) - (map[b].ts || 0);
      })
      .map(function (h) {
        var row = map[h];
        return {
          feature: row.feature,
          feature_id: row.feature_id,
          handle: h,
          ts: row.ts,
        };
      });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          _helium_feature: FEATURE_NAME,
          _helium_feature_id: featureId,
          _helium_attribution: JSON.stringify(ordered),
        },
      }),
    }).catch(function () {});
  }

  /**
   * Failsafe Helium order attribution for pincode on PDP.
   * Only required fields: feature + feature_id. variant / user_bucket omitted.
   */
  function persistPincodeAttribution(featureId, pin) {
    if (!isProductPage()) return;
    var id = featureId || ID_PINCODE_ENTERED;
    var handle = getProductHandle();
    var usedNative = false;
    try {
      var persist =
        window.helium &&
        window.helium.attribution &&
        window.helium.attribution.persistAttribution;
      if (typeof persist === 'function' && handle) {
        persist(handle, {
          feature: FEATURE_NAME,
          feature_id: id,
        });
        usedNative = true;
      }
    } catch (e) {}

    if (!usedNative && handle) {
      writeHeliumCartAttribution(handle, id);
    }

    stampPdpDirectAttribution(id);
    if (pin && isValidPin(pin)) {
      lastAttributedPin = String(pin).trim();
    }
  }

  // function typeIdFromHours(totalHours) {
  //   var hours = Number(totalHours);
  //   if (!isFinite(hours)) return null;
  //   if (hours <= 24) return ID_WITHIN_2_DAYS;
  //   if (hours < 48) return ID_WITHIN_3_DAYS;
  //   return null;
  // }
  function typeIdFromHours(totalHours) {
  var hours = Number(totalHours);
  if (!isFinite(hours)) return null;
  if (hours <= 48) return ID_WITHIN_2_DAYS;
  return ID_WITHIN_3_DAYS;
}

  function trackSelectedSlaView(entries, deliveryMap, pincode) {
    if (!isProductPage() || !entries || !entries.length) return;
    var selected = entries.find(function (entry) {
      return entry.wrap && entry.wrap.querySelector('input[type="radio"]:checked');
    });
    if (!selected || !selected.sku) return;

    var info = deliveryMap && deliveryMap[selected.sku];
    var totalHours =
      info && typeof info === 'object' ? info.totalHours : null;
    var typeId = typeIdFromHours(totalHours);
    if (!typeId) return;

    var key = String(pincode || '') + ':' + selected.sku + ':' + typeId;
    if (lastSlaViewKey === key) return;
    lastSlaViewKey = key;

    trackPincodeSubFeature(typeId, {
      sku: selected.sku,
      totalHours: totalHours,
    });
  }

  function isProductPage() {
    var cfg = config();
    if (typeof cfg.isProductPage === 'boolean') {
      return cfg.isProductPage;
    }
    return document.body.classList.contains('template-product');
  }

  function isValidPin(pin) {
    return /^\d{6}$/.test(String(pin || '').trim());
  }

  function getPincode() {
    var cfg = config();

    if (cfg.isLoggedIn && isValidPin(cfg.customerPincode)) {
      return String(cfg.customerPincode).trim();
    }

    var stored = localStorage.getItem(PIN_KEY);
    if (isValidPin(stored)) {
      return String(stored).trim();
    }

    if (cfg.isLoggedIn) {
      var sessionPin = sessionStorage.getItem(SESSION_PIN_KEY);
      if (isValidPin(sessionPin)) {
        return String(sessionPin).trim();
      }
    }

    return null;
  }

  function hasPersistedPincode() {
    var cfg = config();
    if (cfg.isLoggedIn && isValidPin(cfg.customerPincode)) {
      return true;
    }
    return isValidPin(localStorage.getItem(PIN_KEY));
  }

  function syncGuestPincodeStorage() {
    if (config().isLoggedIn) {
      return;
    }
    if (!isValidPin(localStorage.getItem(PIN_KEY))) {
      sessionStorage.removeItem(SESSION_PIN_KEY);
    }
  }

  function pincodeInputElements() {
    var seen = new Set();
    var nodes = [];

    function add(el) {
      if (el && !seen.has(el)) {
        seen.add(el);
        nodes.push(el);
      }
    }

    add(document.getElementById('pincode_1'));

    document.querySelectorAll('input[name="pincode"]').forEach(add);
    return nodes;
  }

  function syncPincodeInputs(pincode) {
    var value =
      pincode && isValidPin(pincode) ? String(pincode).trim() : pincode ? String(pincode).trim() : '';

    pincodeInputElements().forEach(function (input) {
      if (input.value !== value) {
        input.value = value;
      }
    });
  }

  function clearStoredPincode() {
    if (config().isLoggedIn) {
      return;
    }
    localStorage.removeItem(PIN_KEY);
    sessionStorage.removeItem(SESSION_PIN_KEY);
    syncPincodeInputs('');
    document.dispatchEvent(
      new CustomEvent('wfw:pincode-updated', { detail: { pincode: null } })
    );
  }

  function setPincode(pin) {
    if (!isValidPin(pin)) {
      return false;
    }

    var normalized = String(pin).trim();
    localStorage.setItem(PIN_KEY, normalized);
    if (config().isLoggedIn) {
      sessionStorage.setItem(SESSION_PIN_KEY, normalized);
    }
    syncPincodeInputs(normalized);
    if (isProductPage()) {
      trackPincodeSubFeature(ID_PINCODE_ENTERED, {
        source_of_pin: 'user',
        is_change: !!(lastAttributedPin && lastAttributedPin !== normalized),
      });
      persistPincodeAttribution(ID_PINCODE_ENTERED, normalized);
      skipNextAttributionEvent = true;
    }
    document.dispatchEvent(
      new CustomEvent('wfw:pincode-updated', { detail: { pincode: normalized } })
    );
    return true;
  }

   function badgeLabelFromTotalHours(totalHours) {
  var hours = Number(totalHours);
  if (!isFinite(hours)) return null;
  if (hours <= 48) {
    return { text: 'Within 2 days', title: 'Delivery within 2 days' };
  }
  return { text: 'Within 3 days', title: 'Delivery within 3 days' };
  }

  // function badgeLabelFromTotalHours(totalHours) {
  //   var hours = Number(totalHours);
  //   if (!isFinite(hours)) return null;
  //   if (hours < 24) {
  //     return { text: 'Within 2 days', title: 'Delivery within 2 days' };
  //   }
  //   if (hours <= 48) {
  //     return { text: 'Within 3 days', title: 'Delivery within 3 days' };
  //   }
  //   return null;
  // }
  

  function readVariants(root) {
    var script = root.querySelector('script[type="application/json"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function optionIndexFromGroup(group) {
    var raw = group.getAttribute('data-option-index') || 'option1';
    var num = parseInt(raw.replace('option', ''), 10);
    return isNaN(num) ? 0 : num - 1;
  }

  function currentSelection(root) {
    var selection = {};
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var slug = group.getAttribute('data-option-slug');
      var checked = group.querySelector('input[type="radio"]:checked');
      if (slug && checked) {
        selection[slug] = checked.value;
      }
    });
    return selection;
  }

  function findSizeFieldset(root) {
    return (
      root.querySelector('[data-is-size]') ||
      root.querySelector('[data-option-slug="size"]')
    );
  }

  function findVariantForSize(variants, selection, sizeSlug, sizeIndex, sizeValue, root) {
    return variants.find(function (variant) {
      if (variant.options[sizeIndex] !== sizeValue) {
        return false;
      }

      return Object.keys(selection).every(function (slug) {
        if (slug === sizeSlug) return true;
        var group = root.querySelector('[data-option-slug="' + slug + '"]');
        if (!group) return true;
        var idx = optionIndexFromGroup(group);
        return variant.options[idx] === selection[slug];
      });
    });
  }

  function clearBadges(root) {
    root.querySelectorAll('[data-delivery-badge]').forEach(function (badge) {
      badge.textContent = '';
      badge.removeAttribute('title');
      badge.hidden = true;
    });
  }

  function getSessionCachedMap(cacheKey) {
    try {
      var raw = sessionStorage.getItem(SESSION_CACHE_PREFIX + cacheKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts < CACHE_TTL) {
        return parsed.data;
      }
      sessionStorage.removeItem(SESSION_CACHE_PREFIX + cacheKey);
    } catch (e) {}
    return null;
  }

  function setSessionCachedMap(cacheKey, data) {
    try {
      sessionStorage.setItem(
        SESSION_CACHE_PREFIX + cacheKey,
        JSON.stringify({ ts: Date.now(), data: data })
      );
    } catch (e) {}
  }

  function getCachedDeliveryMap(cacheKey) {
    var memory = cache.get(cacheKey);
    if (memory && Date.now() - memory.ts < CACHE_TTL && isValidDeliveryMap(memory.data)) {
      return memory.data;
    }
    var session = getSessionCachedMap(cacheKey);
    return isValidDeliveryMap(session) ? session : null;
  }

  function isValidDeliveryMap(cached) {
    if (!cached || typeof cached !== 'object' || !cached.map) return false;
    if (typeof cached.serviceable !== 'boolean') return false;
    var keys = Object.keys(cached.map);
    if (!keys.length) return cached.serviceable === false;
    return keys.every(function (sku) {
      var entry = cached.map[sku];
      return entry && typeof entry === 'object' && isFinite(Number(entry.totalHours));
    });
  }

  function emptyDeliveryStatus(fetchFailed) {
    return { map: {}, serviceable: false, fetchFailed: !!fetchFailed };
  }

  function findSelectedVariant(root) {
    var variants = readVariants(root);
    var selection = currentSelection(root);

    return variants.find(function (variant) {
      return Object.keys(selection).every(function (slug) {
        var group = root.querySelector('[data-option-slug="' + slug + '"]');
        if (!group) return true;
        var idx = optionIndexFromGroup(group);
        return variant.options[idx] === selection[slug];
      });
    });
  }

  function formatEstimatedDeliveryDate(isoDate) {
    var parts = String(isoDate || '').split('-');
    if (parts.length !== 3) return null;

    var dt = new Date(
      parseInt(parts[0], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[2], 10)
    );

    var monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ];
    var dayNames = [
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    ];

    return dayNames[dt.getDay()] + ', ' + monthNames[dt.getMonth()] + ' ' + dt.getDate();
  }

  function formatDeliveryMessage(isoDate) {
    var formatted = formatEstimatedDeliveryDate(isoDate);
    if (!formatted) return '';
    return (
      '<span class="span2"><u>Free Delivery:</u> <b>' + formatted + '</b></span>'
    );
  }

  function clearDeliveryDateMessage() {
    var messageEl = document.getElementById('responsemessage');
    if (!messageEl) return;
    messageEl.textContent = '';
    messageEl.classList.remove('fa', 'success', 'error');
  }

  function isFakeInvalidPinError(messageEl) {
    if (!messageEl || !messageEl.classList.contains('error')) return false;
    return /valid 6 digit/i.test(messageEl.textContent || '');
  }

  function clearFakeInvalidPinError() {
    var messageEl = document.getElementById('responsemessage');
    if (!isFakeInvalidPinError(messageEl)) return;
    messageEl.textContent = '';
    messageEl.classList.remove('error');
  }

  function hidePincodeNudge() {
    var nudge = document.getElementById('wfw-pincode-nudge');
    if (nudge) nudge.hidden = true;
  }

  function renderDeliveryDateMessage(isoDate) {
    var messageEl = document.getElementById('responsemessage');
    if (!messageEl || !isoDate) return;

    messageEl.innerHTML = formatDeliveryMessage(isoDate);
    messageEl.classList.remove('error');
    messageEl.classList.add('fa', 'success');
  }

  function availableVariantSkus(root) {
    return readVariants(root)
      .filter(function (variant) {
        return variant.available && variant.sku;
      })
      .map(function (variant) {
        return String(variant.sku).trim();
      });
  }

  function renderPincodeError(message) {
    var messageEl = document.getElementById('responsemessage');
    if (!messageEl) return;
    messageEl.innerHTML = message;
    messageEl.classList.remove('success', 'fa');
    messageEl.classList.add('error');
  }

  async function updateDeliveryDateLine(prefetchedResult) {
    if (!isProductPage()) return;

    var messageEl = document.getElementById('responsemessage');
    if (!messageEl) return;

    var pincode = getPincode();
    if (!pincode) {
      clearDeliveryDateMessage();
      return;
    }

    clearFakeInvalidPinError();

    var root = document.querySelector('variant-radios');
    if (!root) return;

    var variant = findSelectedVariant(root);
    var selectedSku =
      variant && variant.available && variant.sku
        ? String(variant.sku).trim()
        : '';
    var skus = availableVariantSkus(root);
    if (!skus.length && selectedSku) {
      skus = [selectedSku];
    }

    var deliveryResult =
      prefetchedResult || (await fetchDeliveryStatus(skus, pincode));

    if (deliveryResult.fetchFailed) {
      if (!lastPaintedPin || lastPaintedPin !== pincode) {
        renderPincodeError('Could not load delivery estimate. Please try again.');
      }
      return;
    }
    if (!deliveryResult.serviceable) {
      renderPincodeError('Delivery estimate unavailable for this product');
      return;
    }

    var info = selectedSku ? deliveryResult.map[selectedSku] : null;
    if ((!info || !info.estimatedDeliveryDate) && deliveryResult.map) {
      var i;
      for (i = 0; i < skus.length; i++) {
        var row = deliveryResult.map[skus[i]];
        if (row && row.estimatedDeliveryDate) {
          info = row;
          break;
        }
      }
    }

    if (info && info.estimatedDeliveryDate) {
      renderDeliveryDateMessage(info.estimatedDeliveryDate);
      return;
    }

    if (!messageEl.classList.contains('error') || isFakeInvalidPinError(messageEl)) {
      messageEl.textContent = '';
      messageEl.classList.remove('fa', 'success', 'error');
    }
  }

  function applyBadgeResults(entries, deliveryMap) {
    entries.forEach(function (entry) {
      var badge = entry.wrap.querySelector('[data-delivery-badge]');
      if (!badge) return;

      if (!entry.variant || !entry.variant.available || !entry.sku) {
        badge.textContent = '';
        badge.removeAttribute('title');
        badge.hidden = true;
        return;
      }

      var deliveryInfo = deliveryMap[entry.sku];
      var totalHours =
        deliveryInfo && typeof deliveryInfo === 'object'
          ? deliveryInfo.totalHours
          : null;
      var labelInfo = badgeLabelFromTotalHours(totalHours);

      if (labelInfo) {
        badge.textContent = labelInfo.text;
        badge.title = labelInfo.title;
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.removeAttribute('title');
        badge.hidden = true;
      }
    });
  }

  async function fetchDeliveryStatus(skus, pincode) {
    var uniqueSkus = Array.from(new Set(skus.filter(Boolean)));
    if (!uniqueSkus.length || !isValidPin(pincode)) {
      return emptyDeliveryStatus();
    }

    var cacheKey = pincode + ':' + uniqueSkus.slice().sort().join(',');
    var cached = getCachedDeliveryMap(cacheKey);
    if (cached) {
      return cached;
    }

    if (inflight.has(cacheKey)) {
      return inflight.get(cacheKey);
    }

    var promise = (async function () {
      try {
        var url = new URL(API_BASE);
        url.searchParams.set('skus', uniqueSkus.join(','));
        url.searchParams.set('deliveryPostcode', pincode);

        var res = await fetch(url.toString(), {
          headers: { 'x-shopify-shop-domain': SHOP_DOMAIN },
        });
        var json = await res.json();

        if (!json.successful || !Array.isArray(json.results)) {
          return emptyDeliveryStatus();
        }

        var map = {};
        json.results.forEach(function (row) {
          if (row.productSku) {
            map[row.productSku] = {
              deliveryType: row.deliveryType,
              estimatedDeliveryDate: row.estimatedDeliveryDate,
              totalHours: row.totalHours,
            };
          }
        });

        var result = {
          map: map,
          serviceable: Object.keys(map).length > 0,
          fetchFailed: false,
        };

        cache.set(cacheKey, { ts: Date.now(), data: result });
        setSessionCachedMap(cacheKey, result);
        return result;
      } catch (e) {
        return emptyDeliveryStatus(true);
      }
    })();

    inflight.set(cacheKey, promise);
    try {
      return await promise;
    } finally {
      inflight.delete(cacheKey);
    }
  }

  async function applyBadgesForPicker(root) {
    var pincode = getPincode();
    var sizeFieldset = findSizeFieldset(root);

    if (!sizeFieldset) {
      return;
    }

    if (!pincode) {
      clearBadges(root);
      return;
    }

    clearFakeInvalidPinError();

    var variants = readVariants(root);
    var selection = currentSelection(root);
    var sizeSlug = sizeFieldset.getAttribute('data-option-slug');
    var sizeIndex = optionIndexFromGroup(sizeFieldset);
    var optionWraps = sizeFieldset.querySelectorAll('.variant-size-option');

    if (!optionWraps.length) {
      return;
    }

    var entries = [];

    optionWraps.forEach(function (wrap) {
      var label = wrap.querySelector('label.variant-size-label');
      if (!label) return;

      var sizeValue =
        label.getAttribute('data-size-option-value') ||
        label.textContent.trim().split('\n')[0].trim();
      var variant = findVariantForSize(
        variants,
        selection,
        sizeSlug,
        sizeIndex,
        sizeValue,
        root
      );
      var sku = variant && variant.sku ? String(variant.sku).trim() : '';
      entries.push({ wrap: wrap, label: label, sku: sku, variant: variant });
    });

    var skus = entries
      .filter(function (entry) {
        return entry.variant && entry.variant.available && entry.sku;
      })
      .map(function (entry) {
        return entry.sku;
      });

    if (!skus.length) {
      applyBadgeResults(entries, {});
      return;
    }

    var deliveryResult = await fetchDeliveryStatus(skus, pincode);

    if (deliveryResult.fetchFailed) {
      if (lastPaintedPin !== pincode) {
        clearBadges(root);
      }
      updateDeliveryDateLine(deliveryResult);
      return;
    }

    if (!deliveryResult.serviceable) {
      clearBadges(root);
      lastPaintedPin = null;
      updateDeliveryDateLine(deliveryResult);
      return;
    }

    lastPaintedPin = pincode;
    applyBadgeResults(entries, deliveryResult.map);
    trackSelectedSlaView(entries, deliveryResult.map, pincode);
    updateDeliveryDateLine(deliveryResult);
  }

  function initProductBadges() {
    document.querySelectorAll('variant-radios').forEach(function (root) {
      applyBadgesForPicker(root);
    });
  }

  function bindVariantListeners() {
    document.addEventListener('change', function (event) {
      if (!isProductPage()) return;

      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') {
        return;
      }
      var root = input.closest('variant-radios');
      if (!root) return;
      applyBadgesForPicker(root);
    });

  }

  function bindPincodeInputSync() {
    document.addEventListener('wfw:pincode-updated', function (event) {
      var pin =
        event.detail && event.detail.pincode && isValidPin(event.detail.pincode)
          ? String(event.detail.pincode).trim()
          : getPincode();
      syncPincodeInputs(pin || '');
      if (pin) {
        hidePincodeNudge();
      }
      if (isProductPage()) {
        initProductBadges();
        if (pin) {
          if (skipNextAttributionEvent) {
            skipNextAttributionEvent = false;
          } else if (pin !== lastAttributedPin) {
            trackPincodeSubFeature(ID_PINCODE_ENTERED, {
              source_of_pin: 'user',
              is_change: !!lastAttributedPin,
            });
            persistPincodeAttribution(ID_PINCODE_ENTERED, pin);
          }
        }
      }
    });

    function onPinFieldInput(input) {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      var val = input.value.trim();

      if (!val.length) {
        clearFakeInvalidPinError();
        if (!config().isLoggedIn && localStorage.getItem(PIN_KEY)) {
          clearStoredPincode();
        } else {
          syncPincodeInputs(getPincode() || '');
        }
        return;
      }

      syncPincodeInputs(val);

      if (isValidPin(val)) {
        clearFakeInvalidPinError();
        if (getPincode() !== val) {
          setPincode(val);
        }
      } else {
        clearFakeInvalidPinError();
      }
    }

    pincodeInputElements().forEach(function (input) {
      input.addEventListener('input', function () {
        onPinFieldInput(input);
      });
      input.addEventListener('change', function () {
        onPinFieldInput(input);
      });
      // Protected pincode.js still writes the 6-digit error on keyup; clear it after.
      input.addEventListener('keyup', function () {
        setTimeout(function () {
          onPinFieldInput(input);
        }, 0);
      });
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== PIN_KEY) return;
      syncPincodeInputs(getPincode() || '');
      if (isProductPage()) {
        initProductBadges();
      }
    });
  }

  function shouldShowPincodeNudge() {
    return isProductPage();
  }

  function showPincodeNudge() {
    var nudge = document.getElementById('wfw-pincode-nudge');
    if (!nudge || !shouldShowPincodeNudge()) return;
    if (hasPersistedPincode()) return;
    nudge.hidden = false;
  }

  function initPincodeNudge() {
    if (!shouldShowPincodeNudge()) {
      return;
    }
    if (hasPersistedPincode()) {
      hidePincodeNudge();
      return;
    }

    var section =
      document.getElementById('wfw-pincode-section') ||
      document.querySelector('[data-wfw-pincode-section]');
    var nudge = document.getElementById('wfw-pincode-nudge');
    if (!section || !nudge) return;

    var dwellTimer = null;
    var hasShown = false;

    function clearDwell() {
      if (dwellTimer) {
        clearTimeout(dwellTimer);
        dwellTimer = null;
      }
    }

    function startDwell() {
      clearDwell();
      if (hasShown) return;
      dwellTimer = setTimeout(function () {
        showPincodeNudge();
        hasShown = true;
      }, NUDGE_DWELL_MS);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              startDwell();
            } else {
              clearDwell();
            }
          });
        },
        { threshold: [0, 0.5, 1] }
      );
      observer.observe(section);
    } else {
      startDwell();
    }

    var actionBtn = document.getElementById('wfw-pincode-nudge-action');
    var pinInput = document.getElementById('pincode_1');

    if (actionBtn && pinInput) {
      actionBtn.addEventListener('click', function () {
        pinInput.focus();
        pinInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function initLoggedInPincode() {
    var cfg = config();
    if (cfg.isLoggedIn && isValidPin(cfg.customerPincode)) {
      sessionStorage.setItem(SESSION_PIN_KEY, String(cfg.customerPincode).trim());
    }
  }

  function init() {
    syncGuestPincodeStorage();
    initLoggedInPincode();
    bindVariantListeners();
    syncPincodeInputs(getPincode() || '');

    if (isProductPage()) {
      var existingPin = getPincode();
      if (!prefilledAttributionDone && existingPin) {
        prefilledAttributionDone = true;
        trackPincodeSubFeature(ID_SAVED_PINCODE, {
          source_of_pin: sourceOfExistingPin(existingPin),
        });
        persistPincodeAttribution(ID_SAVED_PINCODE, existingPin);
      }
    }

    bindPincodeInputSync();

    if (!isProductPage()) {
      return;
    }

    initProductBadges();
    initPincodeNudge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.WFWDeliverySlaApi = {
    getPincode: getPincode,
    setPincode: setPincode,
    refreshBadges: initProductBadges,
    updateDeliveryDateLine: updateDeliveryDateLine,
  };
})();




// (function () {
//   'use strict';

//   var API_BASE = 'https://backend-pre-prod.up.railway.app/api/delivery/status';
//   var SHOP_DOMAIN = 'shopforw.myshopify.com';
//   var PIN_KEY = 'ExistPincode';
//   var SESSION_PIN_KEY = 'WfwSessionPincode';
//   var SESSION_CACHE_PREFIX = 'WfwDeliveryCache:v4:';
//   var NUDGE_DWELL_MS = 2000;
//   var CACHE_TTL = 5 * 60 * 1000;
//   var cache = new Map();
//   var inflight = new Map();

//   function config() {
//     return window.WFWDeliverySla || {};
//   }

//   function isProductPage() {
//     var cfg = config();
//     if (typeof cfg.isProductPage === 'boolean') {
//       return cfg.isProductPage;
//     }
//     return document.body.classList.contains('template-product');
//   }

//   function isValidPin(pin) {
//     return /^\d{6}$/.test(String(pin || '').trim());
//   }

//   function getPincode() {
//     var cfg = config();

//     if (cfg.isLoggedIn && isValidPin(cfg.customerPincode)) {
//       return String(cfg.customerPincode).trim();
//     }

//     var stored = localStorage.getItem(PIN_KEY);
//     if (isValidPin(stored)) {
//       return String(stored).trim();
//     }

//     if (cfg.isLoggedIn) {
//       var sessionPin = sessionStorage.getItem(SESSION_PIN_KEY);
//       if (isValidPin(sessionPin)) {
//         return String(sessionPin).trim();
//       }
//     }

//     return null;
//   }

//   function hasPersistedPincode() {
//     var cfg = config();
//     if (cfg.isLoggedIn && isValidPin(cfg.customerPincode)) {
//       return true;
//     }
//     return isValidPin(localStorage.getItem(PIN_KEY));
//   }

//   function syncGuestPincodeStorage() {
//     if (config().isLoggedIn) {
//       return;
//     }
//     if (!isValidPin(localStorage.getItem(PIN_KEY))) {
//       sessionStorage.removeItem(SESSION_PIN_KEY);
//     }
//   }

//   function pincodeInputElements() {
//     var seen = new Set();
//     var nodes = [];

//     function add(el) {
//       if (el && !seen.has(el)) {
//         seen.add(el);
//         nodes.push(el);
//       }
//     }

//     add(document.getElementById('pincode_1'));

//     document.querySelectorAll('input[name="pincode"]').forEach(add);
//     return nodes;
//   }

//   function syncPincodeInputs(pincode) {
//     var value =
//       pincode && isValidPin(pincode) ? String(pincode).trim() : pincode ? String(pincode).trim() : '';

//     pincodeInputElements().forEach(function (input) {
//       if (input.value !== value) {
//         input.value = value;
//       }
//     });
//   }

//   function clearStoredPincode() {
//     if (config().isLoggedIn) {
//       return;
//     }
//     localStorage.removeItem(PIN_KEY);
//     sessionStorage.removeItem(SESSION_PIN_KEY);
//     syncPincodeInputs('');
//     document.dispatchEvent(
//       new CustomEvent('wfw:pincode-updated', { detail: { pincode: null } })
//     );
//   }

//   function setPincode(pin) {
//     if (!isValidPin(pin)) {
//       return false;
//     }

//     var normalized = String(pin).trim();
//     localStorage.setItem(PIN_KEY, normalized);
//     if (config().isLoggedIn) {
//       sessionStorage.setItem(SESSION_PIN_KEY, normalized);
//     }
//     syncPincodeInputs(normalized);
//     document.dispatchEvent(
//       new CustomEvent('wfw:pincode-updated', { detail: { pincode: normalized } })
//     );
//     return true;
//   }

//   function badgeLabelFromTotalHours(totalHours) {
//     var hours = Number(totalHours);
//     if (!isFinite(hours)) return null;
//     if (hours < 24) {
//       return { text: '24 Hrs', title: 'Delivery in 24 Hrs' };
//     }
//     if (hours <= 48) {
//       return { text: '24–48 Hrs', title: 'Delivery in 48 Hrs' };
//     }
//     return null;
//   }

//   function readVariants(root) {
//     var script = root.querySelector('script[type="application/json"]');
//     if (!script) return [];
//     try {
//       return JSON.parse(script.textContent);
//     } catch (e) {
//       return [];
//     }
//   }

//   function optionIndexFromGroup(group) {
//     var raw = group.getAttribute('data-option-index') || 'option1';
//     var num = parseInt(raw.replace('option', ''), 10);
//     return isNaN(num) ? 0 : num - 1;
//   }

//   function currentSelection(root) {
//     var selection = {};
//     root.querySelectorAll('[data-option-index]').forEach(function (group) {
//       var slug = group.getAttribute('data-option-slug');
//       var checked = group.querySelector('input[type="radio"]:checked');
//       if (slug && checked) {
//         selection[slug] = checked.value;
//       }
//     });
//     return selection;
//   }

//   function findSizeFieldset(root) {
//     return (
//       root.querySelector('[data-is-size]') ||
//       root.querySelector('[data-option-slug="size"]')
//     );
//   }

//   function findVariantForSize(variants, selection, sizeSlug, sizeIndex, sizeValue, root) {
//     return variants.find(function (variant) {
//       if (variant.options[sizeIndex] !== sizeValue) {
//         return false;
//       }

//       return Object.keys(selection).every(function (slug) {
//         if (slug === sizeSlug) return true;
//         var group = root.querySelector('[data-option-slug="' + slug + '"]');
//         if (!group) return true;
//         var idx = optionIndexFromGroup(group);
//         return variant.options[idx] === selection[slug];
//       });
//     });
//   }

//   function clearBadges(root) {
//     root.querySelectorAll('[data-delivery-badge]').forEach(function (badge) {
//       badge.textContent = '';
//       badge.removeAttribute('title');
//       badge.hidden = true;
//     });
//   }

//   function getSessionCachedMap(cacheKey) {
//     try {
//       var raw = sessionStorage.getItem(SESSION_CACHE_PREFIX + cacheKey);
//       if (!raw) return null;
//       var parsed = JSON.parse(raw);
//       if (Date.now() - parsed.ts < CACHE_TTL) {
//         return parsed.data;
//       }
//       sessionStorage.removeItem(SESSION_CACHE_PREFIX + cacheKey);
//     } catch (e) {}
//     return null;
//   }

//   function setSessionCachedMap(cacheKey, data) {
//     try {
//       sessionStorage.setItem(
//         SESSION_CACHE_PREFIX + cacheKey,
//         JSON.stringify({ ts: Date.now(), data: data })
//       );
//     } catch (e) {}
//   }

//   function getCachedDeliveryMap(cacheKey) {
//     var memory = cache.get(cacheKey);
//     if (memory && Date.now() - memory.ts < CACHE_TTL && isValidDeliveryMap(memory.data)) {
//       return memory.data;
//     }
//     var session = getSessionCachedMap(cacheKey);
//     return isValidDeliveryMap(session) ? session : null;
//   }

//   function isValidDeliveryMap(cached) {
//     if (!cached || typeof cached !== 'object' || !cached.map) return false;
//     if (typeof cached.serviceable !== 'boolean') return false;
//     var keys = Object.keys(cached.map);
//     if (!keys.length) return cached.serviceable === false;
//     return keys.every(function (sku) {
//       var entry = cached.map[sku];
//       return entry && typeof entry === 'object' && isFinite(Number(entry.totalHours));
//     });
//   }

//   function emptyDeliveryStatus(fetchFailed) {
//     return { map: {}, serviceable: false, fetchFailed: !!fetchFailed };
//   }

//   function findSelectedVariant(root) {
//     var variants = readVariants(root);
//     var selection = currentSelection(root);

//     return variants.find(function (variant) {
//       return Object.keys(selection).every(function (slug) {
//         var group = root.querySelector('[data-option-slug="' + slug + '"]');
//         if (!group) return true;
//         var idx = optionIndexFromGroup(group);
//         return variant.options[idx] === selection[slug];
//       });
//     });
//   }

//   function formatEstimatedDeliveryDate(isoDate) {
//     var parts = String(isoDate || '').split('-');
//     if (parts.length !== 3) return null;

//     var dt = new Date(
//       parseInt(parts[0], 10),
//       parseInt(parts[1], 10) - 1,
//       parseInt(parts[2], 10)
//     );

//     var monthNames = [
//       'January', 'February', 'March', 'April', 'May', 'June',
//       'July', 'August', 'September', 'October', 'November', 'December',
//     ];
//     var dayNames = [
//       'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
//     ];

//     return dayNames[dt.getDay()] + ', ' + monthNames[dt.getMonth()] + ' ' + dt.getDate();
//   }

//   function formatDeliveryMessage(isoDate) {
//     var formatted = formatEstimatedDeliveryDate(isoDate);
//     if (!formatted) return '';
//     return (
//       '<span class="span2"><u>Free Delivery:</u> <b>' + formatted + '</b></span>'
//     );
//   }

//   function clearDeliveryDateMessage() {
//     var messageEl = document.getElementById('responsemessage');
//     if (!messageEl) return;
//     messageEl.textContent = '';
//     messageEl.classList.remove('fa', 'success', 'error');
//   }

//   function renderDeliveryDateMessage(isoDate) {
//     var messageEl = document.getElementById('responsemessage');
//     if (!messageEl || !isoDate) return;

//     messageEl.innerHTML = formatDeliveryMessage(isoDate);
//     messageEl.classList.remove('error');
//     messageEl.classList.add('fa', 'success');
//   }

//   function availableVariantSkus(root) {
//     return readVariants(root)
//       .filter(function (variant) {
//         return variant.available && variant.sku;
//       })
//       .map(function (variant) {
//         return String(variant.sku).trim();
//       });
//   }

//   function renderPincodeError(message) {
//     var messageEl = document.getElementById('responsemessage');
//     if (!messageEl) return;
//     messageEl.innerHTML = message;
//     messageEl.classList.remove('success', 'fa');
//     messageEl.classList.add('error');
//   }

//   async function updateDeliveryDateLine(prefetchedResult) {
//     if (!isProductPage()) return;

//     var messageEl = document.getElementById('responsemessage');
//     if (!messageEl) return;

//     var pincode = getPincode();
//     if (!pincode) {
//       clearDeliveryDateMessage();
//       return;
//     }

//     var root = document.querySelector('variant-radios');
//     if (!root) return;

//     var variant = findSelectedVariant(root);
//     if (!variant || !variant.available || !variant.sku) {
//       if (!messageEl.classList.contains('error')) {
//         messageEl.textContent = '';
//         messageEl.classList.remove('fa', 'success');
//       }
//       return;
//     }

//     var selectedSku = String(variant.sku).trim();
//     var skus = availableVariantSkus(root);
//     if (!skus.length) {
//       skus = [selectedSku];
//     }

//     var deliveryResult = prefetchedResult || (await fetchDeliveryStatus(skus, pincode));

//    if (deliveryResult.fetchFailed) {
//     clearDeliveryDateMessage();
//     return;
//    }
//     if (!deliveryResult.serviceable) {
//       renderPincodeError('Delivery estimate unavailable for this product');
//       return;
//     }

//     var info = deliveryResult.map[selectedSku];

//     if (info && info.estimatedDeliveryDate) {
//       renderDeliveryDateMessage(info.estimatedDeliveryDate);
//       return;
//     }

//     if (!messageEl.classList.contains('error')) {
//       messageEl.textContent = '';
//       messageEl.classList.remove('fa', 'success');
//     }
//   }

//   function applyBadgeResults(entries, deliveryMap) {
//     entries.forEach(function (entry) {
//       var badge = entry.wrap.querySelector('[data-delivery-badge]');
//       if (!badge) return;

//       if (!entry.variant || !entry.variant.available || !entry.sku) {
//         badge.textContent = '';
//         badge.removeAttribute('title');
//         badge.hidden = true;
//         return;
//       }

//       var deliveryInfo = deliveryMap[entry.sku];
//       var totalHours =
//         deliveryInfo && typeof deliveryInfo === 'object'
//           ? deliveryInfo.totalHours
//           : null;
//       var labelInfo = badgeLabelFromTotalHours(totalHours);

//       if (labelInfo) {
//         badge.textContent = labelInfo.text;
//         badge.title = labelInfo.title;
//         badge.hidden = false;
//       } else {
//         badge.textContent = '';
//         badge.removeAttribute('title');
//         badge.hidden = true;
//       }
//     });
//   }

//   async function fetchDeliveryStatus(skus, pincode) {
//     var uniqueSkus = Array.from(new Set(skus.filter(Boolean)));
//     if (!uniqueSkus.length || !isValidPin(pincode)) {
//       return emptyDeliveryStatus();
//     }

//     var cacheKey = pincode + ':' + uniqueSkus.slice().sort().join(',');
//     var cached = getCachedDeliveryMap(cacheKey);
//     if (cached) {
//       return cached;
//     }

//     if (inflight.has(cacheKey)) {
//       return inflight.get(cacheKey);
//     }

//     var promise = (async function () {
//       try {
//         var url = new URL(API_BASE);
//         url.searchParams.set('skus', uniqueSkus.join(','));
//         url.searchParams.set('deliveryPostcode', pincode);

//         var res = await fetch(url.toString(), {
//           headers: { 'x-shopify-shop-domain': SHOP_DOMAIN },
//         });
//         var json = await res.json();

//         if (!json.successful || !Array.isArray(json.results)) {
//           return emptyDeliveryStatus();
//         }

//         var map = {};
//         json.results.forEach(function (row) {
//           if (row.productSku) {
//             map[row.productSku] = {
//               deliveryType: row.deliveryType,
//               estimatedDeliveryDate: row.estimatedDeliveryDate,
//               totalHours: row.totalHours,
//             };
//           }
//         });

//         var result = {
//           map: map,
//           serviceable: Object.keys(map).length > 0,
//           fetchFailed: false,
//         };

//         cache.set(cacheKey, { ts: Date.now(), data: result });
//         setSessionCachedMap(cacheKey, result);
//         return result;
//       } catch (e) {
//         return emptyDeliveryStatus(true);
//       }
//     })();

//     inflight.set(cacheKey, promise);
//     try {
//       return await promise;
//     } finally {
//       inflight.delete(cacheKey);
//     }
//   }

//   async function applyBadgesForPicker(root) {
//     var pincode = getPincode();
//     var sizeFieldset = findSizeFieldset(root);

//     if (!sizeFieldset) {
//       return;
//     }

//     if (!pincode) {
//       clearBadges(root);
//       return;
//     }

//     var variants = readVariants(root);
//     var selection = currentSelection(root);
//     var sizeSlug = sizeFieldset.getAttribute('data-option-slug');
//     var sizeIndex = optionIndexFromGroup(sizeFieldset);
//     var optionWraps = sizeFieldset.querySelectorAll('.variant-size-option');

//     if (!optionWraps.length) {
//       return;
//     }

//     var entries = [];

//     optionWraps.forEach(function (wrap) {
//       var label = wrap.querySelector('label.variant-size-label');
//       if (!label) return;

//       var sizeValue =
//         label.getAttribute('data-size-option-value') ||
//         label.textContent.trim().split('\n')[0].trim();
//       var variant = findVariantForSize(
//         variants,
//         selection,
//         sizeSlug,
//         sizeIndex,
//         sizeValue,
//         root
//       );
//       var sku = variant && variant.sku ? String(variant.sku).trim() : '';
//       entries.push({ wrap: wrap, label: label, sku: sku, variant: variant });
//     });

//     var skus = entries
//       .filter(function (entry) {
//         return entry.variant && entry.variant.available && entry.sku;
//       })
//       .map(function (entry) {
//         return entry.sku;
//       });

//     if (!skus.length) {
//       applyBadgeResults(entries, {});
//       return;
//     }

//     var deliveryResult = await fetchDeliveryStatus(skus, pincode);

//     if (!deliveryResult.serviceable) {
//       clearBadges(root);
//       updateDeliveryDateLine(deliveryResult);
//       return;
//     }

//     applyBadgeResults(entries, deliveryResult.map);
//     updateDeliveryDateLine(deliveryResult);
//   }

//   function initProductBadges() {
//     document.querySelectorAll('variant-radios').forEach(function (root) {
//       applyBadgesForPicker(root);
//     });
//   }

//   function bindVariantListeners() {
//     document.addEventListener('change', function (event) {
//       if (!isProductPage()) return;

//       var input = event.target;
//       if (!(input instanceof HTMLInputElement) || input.type !== 'radio') {
//         return;
//       }
//       var root = input.closest('variant-radios');
//       if (!root) return;
//       applyBadgesForPicker(root);
//     });

//   }

//   function bindPincodeInputSync() {
//     document.addEventListener('wfw:pincode-updated', function (event) {
//       var pin =
//         event.detail && event.detail.pincode && isValidPin(event.detail.pincode)
//           ? String(event.detail.pincode).trim()
//           : getPincode();
//       syncPincodeInputs(pin || '');
//       if (isProductPage()) {
//         initProductBadges();
//       }
//     });

//     pincodeInputElements().forEach(function (input) {
//       input.addEventListener('input', function () {
//         input.value = input.value.replace(/\D/g, '').slice(0, 6);
//         var val = input.value.trim();

//         if (!val.length) {
//           if (!config().isLoggedIn && localStorage.getItem(PIN_KEY)) {
//             clearStoredPincode();
//           } else {
//             syncPincodeInputs(getPincode() || '');
//           }
//           return;
//         }

//         syncPincodeInputs(val);
//       });
//     });

//     window.addEventListener('storage', function (event) {
//       if (event.key !== PIN_KEY) return;
//       syncPincodeInputs(getPincode() || '');
//       if (isProductPage()) {
//         initProductBadges();
//       }
//     });
//   }

//   function shouldShowPincodeNudge() {
//     return isProductPage();
//   }

//   function showPincodeNudge() {
//     var nudge = document.getElementById('wfw-pincode-nudge');
//     if (!nudge || !shouldShowPincodeNudge()) return;
//     nudge.hidden = false;
//   }

//   function initPincodeNudge() {
//     if (!shouldShowPincodeNudge()) {
//       return;
//     }

//     var section =
//       document.getElementById('wfw-pincode-section') ||
//       document.querySelector('[data-wfw-pincode-section]');
//     var nudge = document.getElementById('wfw-pincode-nudge');
//     if (!section || !nudge) return;

//     var dwellTimer = null;
//     var hasShown = false;

//     function clearDwell() {
//       if (dwellTimer) {
//         clearTimeout(dwellTimer);
//         dwellTimer = null;
//       }
//     }

//     function startDwell() {
//       clearDwell();
//       if (hasShown) return;
//       dwellTimer = setTimeout(function () {
//         showPincodeNudge();
//         hasShown = true;
//       }, NUDGE_DWELL_MS);
//     }

//     if ('IntersectionObserver' in window) {
//       var observer = new IntersectionObserver(
//         function (entries) {
//           entries.forEach(function (entry) {
//             if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//               startDwell();
//             } else {
//               clearDwell();
//             }
//           });
//         },
//         { threshold: [0, 0.5, 1] }
//       );
//       observer.observe(section);
//     } else {
//       startDwell();
//     }

//     var actionBtn = document.getElementById('wfw-pincode-nudge-action');
//     var pinInput = document.getElementById('pincode_1');

//     if (actionBtn && pinInput) {
//       actionBtn.addEventListener('click', function () {
//         pinInput.focus();
//         pinInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
//       });
//     }
//   }

//   function initLoggedInPincode() {
//     var cfg = config();
//     if (cfg.isLoggedIn && isValidPin(cfg.customerPincode)) {
//       sessionStorage.setItem(SESSION_PIN_KEY, String(cfg.customerPincode).trim());
//     }
//   }

//   function init() {
//     syncGuestPincodeStorage();
//     initLoggedInPincode();
//     bindVariantListeners();
//     bindPincodeInputSync();
//     syncPincodeInputs(getPincode() || '');

//     if (!isProductPage()) {
//       return;
//     }

//     initProductBadges();
//     initPincodeNudge();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   window.WFWDeliverySlaApi = {
//     getPincode: getPincode,
//     setPincode: setPincode,
//     refreshBadges: initProductBadges,
//     updateDeliveryDateLine: updateDeliveryDateLine,
//   };
// })();
